import React from "react";
import { motion } from "framer-motion";
import { Fuel, GlassWater, Check } from "lucide-react";

const hidro = [
  "Distribuidoras de combustible y operadores mayoristas",
  "Estaciones de servicio independientes",
  "Empresas de transporte con grandes flotas",
  "Sector agrícola (gasóleo bonificado)",
  "Industrias con alto consumo energético",
  "Ayuntamientos y administraciones públicas",
  "Importadores y exportadores de productos petrolíferos",
];

const alc = [
  "Bodegas y destilerías sin depósito fiscal propio",
  "Importadores de alcohol a granel",
  "Fabricantes de productos de limpieza, farmacia y cosmética",
  "Distribuidores mayoristas de bebidas alcohólicas",
  "Empresas que operan en mercado intracomunitario",
  "Operadores logísticos del sector",
];

const Block = ({ Icon, title, items, accent, testid }) => (
  <motion.div
    initial={{ opacity: 0, y: 30 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.6 }}
    data-testid={testid}
    className="relative bg-white rounded-3xl border border-slate-200 p-8 md:p-10 shadow-sm hover:shadow-xl hover:shadow-[#0066FF]/5 transition-shadow"
  >
    <div className="flex items-center gap-4 mb-6">
      <div className="w-14 h-14 rounded-2xl flex items-center justify-center" style={{ backgroundColor: accent }}>
        <Icon className="w-7 h-7 text-white" strokeWidth={1.7} />
      </div>
      <h3 className="text-2xl md:text-3xl font-bold text-[#0A1628]" style={{ fontFamily: "Poppins" }}>
        {title}
      </h3>
    </div>
    <ul className="space-y-3">
      {items.map((s) => (
        <li key={s} className="flex items-start gap-3 text-slate-700">
          <Check className="w-5 h-5 mt-0.5 flex-shrink-0" style={{ color: accent }} strokeWidth={2.5} />
          <span className="leading-relaxed">{s}</span>
        </li>
      ))}
    </ul>
  </motion.div>
);

export const Sectors = () => {
  return (
    <section
      id="sectores"
      data-testid="sectors-section"
      className="bg-[#F5F7FA] py-24 md:py-32 text-[#1A1A2E]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="max-w-3xl"
        >
          <span className="text-xs uppercase tracking-[0.25em] text-[#0066FF] font-semibold">
            A quién servimos
          </span>
          <h2
            className="mt-4 text-3xl md:text-4xl lg:text-5xl font-bold leading-tight"
            style={{ fontFamily: "Poppins" }}
          >
            Sectores con los que trabajamos.
          </h2>
          <p className="mt-5 text-slate-700 text-lg">
            Acompañamos a empresas de toda la cadena fiscal, desde productores
            hasta distribuidores y exportadores.
          </p>
        </motion.div>

        <div className="mt-14 grid lg:grid-cols-2 gap-6">
          <Block Icon={GlassWater} title="Alcohol y Bebidas Derivadas" items={alc} accent="#0066FF" testid="sectors-block-alcohol" />
          <Block Icon={Fuel} title="Hidrocarburos" items={hidro} accent="#FF6B00" testid="sectors-block-hidrocarburos" />
        </div>
      </div>
    </section>
  );
};

export default Sectors;
